@if (loading) {
  <div class="d-flex justify-content-center">
    <ix-spinner size="large" class="mt-5"></ix-spinner>
  </div>
} @else {
  <div class="input-field-size-max">
    <div class="d-flex justify-content-between mt-4">
      <ix-typography format="h4" id="orgFormCatenaHeader">
        {{ 'organizations.settings.catena_network' | translate }}
      </ix-typography>
      <ix-toggle
        (checkedChange)="isCxEnabled = !isCxEnabled"
        [checked]="isCxEnabled"
      ></ix-toggle>
    </div>
    @if (isCxEnabled && !connectorConfig) {
      <div class="d-flex justify-content-center mt-4">
        <div>
          <ix-empty-state
            id="orgFormEmptyState"
            action="{{ 'organizations.settings.empty.action' | translate }}"
            header="{{ 'organizations.settings.empty.header' | translate }}"
            icon="disconnected"
            subHeader="{{ 'organizations.settings.empty.subheader' | translate }}"
            (actionClick)="onAddClick(false)"/>
            <div class="divider my-4">{{ 'login.or' | translate }}</div>
            <div class="w-100 d-flex justify-content-center">
              <ix-button
                (click)="onAddClick(true)"
                onkeypress=""
                id="orgFormOwnEDCButton"
                variant="subtle-primary"
                >
                {{ 'organizations.settings.req_own_edc' | translate }}
              </ix-button>
            </div>
          </div>
        </div>
      } @else if (connectorConfig && connectorConfig.state === 'pending') {
        <ix-empty-state
          class="mt-5"
          id="orgFormPendingState"
          header="{{'organizations.settings.create_edc.request_received_header' | translate}}"
          subHeader="{{'organizations.settings.create_edc.request_received_subheader' | translate }}"
          icon="hourglass"/>
        } @else if (connectorConfig && connectorConfig.state === 'active') {
          <ng-template
            *ngTemplateOutlet="connectorInputForm;context: {isSelfHosted: connectorConfig.hostedService}"/>
            <div class="col-md-12 input-field-size-max mt-4">
              <ix-modal-footer>
                <ix-button
                  class="close-modal"
                  (click)="onCancelEditClick()"
                  onkeypress=""
                  id="orgFormEditEDCModalNoButton"
                  variant="secondary">
                  {{ 'general.cancel' | translate }}
                </ix-button>
                <ix-button
                  [loading]="loadingSubSequence"
                  [disabled]="!connectorForm.valid"
                  (click)="onUpdateEDCClick()"
                  onkeypress=""
                  id="orgFormEditEDCModalYesButton"
                  variant="primary">
                  {{ 'general.save' | translate }}
                </ix-button>
              </ix-modal-footer>
            </div>
          }
        </div>
      }


      <ng-template #addConfigModal let-modal>
        <ix-modal>
          <ix-modal-header id="orgFormAddEDCModalHeader">
            {{ 'organizations.settings.create_edc.header' | translate }}
          </ix-modal-header>
          @if (connectorForm) {
            <ix-modal-content id="orgFormAddEDCModalContent">
              <ng-template
                *ngTemplateOutlet="connectorInputForm; context: {isSelfHosted: modal.data}"/>
              </ix-modal-content>
            }
            <ix-modal-footer>
              <ix-button
                (click)="modal.dismiss()"
                class="close-modal"
                id="orgFormAddEDCModalNoButton"
                onkeypress=""
                variant="secondary">
                {{ 'general.cancel' | translate }}
              </ix-button>
              <ix-button
                (click)="onSaveClick(modal)"
                [disabled]="!connectorForm.valid"
                [loading]="loadingSubSequence"
                id="orgFormAddEDCModalYesButton"
                onkeypress=""
                variant="primary">
                {{ 'general.add' | translate }}
              </ix-button>
            </ix-modal-footer>
          </ix-modal>
        </ng-template>

        <ng-template #connectorInputForm let-isSelfHosted="isSelfHosted">
          <form [formGroup]="connectorForm" class="needs-validation" novalidate>
            <div class="d-flex justify-content-start align-items-baseline">
              <ix-typography format="h4" id="connectorFormUserEDCHeader">{{
                (type === 'consumer'
                ? 'organizations.settings.create_edc.consumer_subheader'
                : 'organizations.settings.create_edc.provider_subheader'
                ) | translate
                }}
              </ix-typography>
              @if (!isSelfHosted) {
                <ix-pill class="ms-2" outline>
                  {{ 'organizations.settings.edc_type_pill_text' | translate }}
                </ix-pill>
              }
            </div>

            @for (errorMessage of errorMessages; track errorMessage) {
              <ix-event-list>
                <ix-event-list-item class="no-pointer-event"
                  item-color="--theme-color-alarm">
                  {{ errorMessage }}
                </ix-event-list-item>
              </ix-event-list>
            }

            <ix-input
              [class.ix-invalid]="connectorForm.controls['bpn'].invalid && !connectorForm.controls['bpn'].untouched"
              [id]="type + 'ConnectorFormBPNInput'"
              [invalidText]="getErrorMessage('bpn') | translate"
              [label]="'organizations.settings.create_edc.bpn_label' | translate"
              class="col-md-12 mt-2 input-field-size-max"
              formControlName="bpn"
              type="text"/>


              <!-- provided -->
              <ix-input
      [class.ix-invalid]="connectorForm.controls['technicalUser'].invalid 
        && !connectorForm.controls['technicalUser'].untouched"
                [id]="type + 'ConnectorFormTechnicalUserInput'"
                [invalidText]="getErrorMessage('technicalUser') | translate"
                [label]="'organizations.settings.create_edc.technical_user_label' | translate"
                class="col-md-12 mt-2 input-field-size-max"
                formControlName="technicalUser"
                type="text"/>

                <!-- provided -->
                <ix-input
      [class.ix-invalid]="connectorForm.controls['secret'].invalid 
        && !connectorForm.controls['secret'].untouched"
                  [id]="type + 'ConnectorFormTechnicalSecretInput'"
                  [invalidText]="getErrorMessage('secret') | translate"
                  [label]="'organizations.settings.create_edc.secret_label' | translate"
                  class="col-md-12 mt-2 input-field-size-max"
                  formControlName="secret"
                  type="password"/>

                  @if (isSelfHosted) {
                    <!-- self hosted -->
                    <ix-input class="col-md-12 mt-2 input-field-size-max"
                      [id]="type + 'ConnectorFormUrlInput'"
                      [label]="'organizations.settings.create_edc.url_label_' + type | translate"
                      formControlName="edcUrl"
                      type="text"
                [class.ix-invalid]="connectorForm.controls['edcUrl'].invalid 
                  && !connectorForm.controls['edcUrl'].untouched"
                      [invalidText]="getErrorMessage('edcUrl') | translate"/>

                      <!-- self hosted -->
                      <ix-input class="col-md-12 mt-2 input-field-size-max"
                        [id]="type + 'ConnectorFormApiKeyInput'"
                        [label]="'organizations.settings.create_edc.api_key_label_' + type | translate"
                        formControlName="edcApiKey"
                        type="password"
                [class.ix-invalid]="connectorForm.controls['edcApiKey'].invalid 
                  && !connectorForm.controls['edcApiKey'].untouched"
                        [invalidText]="getErrorMessage('edcApiKey') | translate"/>
                      }

                      @if (isSelfHosted && type === 'provider') {
                        <!-- self hosted && provider -->
                        <ix-input class="col-md-12 mt-2 input-field-size-max"
                          id="providerConnectorFormDtrUrlInput"
                          [label]="'organizations.settings.create_edc.dtr_url_label_provider' | translate"
                          formControlName="dtrUrl"
                          type="text"
                [class.ix-invalid]="connectorForm.controls['dtrUrl'].invalid 
                  && !connectorForm.controls['dtrUrl'].untouched"
                          [invalidText]="getErrorMessage('dtrUrl') | translate"/>

                          <!-- self hosted && provider -->
                          <ix-input class="col-md-12 mt-2 input-field-size-max"
                            id="providerConnectorFormDtrApiKeyInput"
                            [label]="'organizations.settings.create_edc.dtr_api_key_label_provider' | translate"
                            formControlName="dtrApiKey"
                            type="password"
                [class.ix-invalid]="connectorForm.controls['dtrApiKey'].invalid 
                  && !connectorForm.controls['dtrApiKey'].untouched"
                            [invalidText]="getErrorMessage('dtrApiKey') | translate"/>
                          }

                          @if (type === 'provider') {
                            <ix-checkbox
                              class="mt-3"
                              formControlName="autoSyncOnComplete"
                              [label]="'organizations.settings.create_edc.auto_sync_on_complete_label' | translate"
                            ></ix-checkbox>
                          }
                        </form>
                      </ng-template>

                      <ng-template #deleteModal let-modal>
                        <ix-modal>
                          <ix-modal-header id="orgFormDeleteModalHeader"
                            >{{ 'organizations.settings.delete_header' | translate }}
                          </ix-modal-header>
                          <ix-modal-content id="orgFormDeleteModalContent"
                            >{{ 'organizations.settings.delete_content' | translate }}
                          </ix-modal-content>
                          <ix-modal-footer>
                            <ix-button
                              (click)="modal.close(true)"
                              class="dismiss-modal"
                              id="orgFormDeleteModalYesButton"
                              onkeypress=""
                              variant="secondary">
                              {{ 'general.yes' | translate }}
                            </ix-button>
                            <ix-button
                              (click)="modal.dismiss()"
                              class="close-modal"
                              id="orgFormDeleteModalNoButton"
                              onkeypress=""
                              variant="primary">
                              {{ 'general.no' | translate }}
                            </ix-button>
                          </ix-modal-footer>
                        </ix-modal>
                      </ng-template>

                      <ng-template #cancelEditModal let-modal>
                        <ix-modal>
                          <ix-modal-header id="orgFormCancelEditModalHeader"
                            >{{ 'organizations.settings.edit_cancel_header' | translate }}
                          </ix-modal-header>
                          <ix-modal-content id="orgFormCancelEditModalContent"
                            >{{
                            'organizations.settings.edit_cancel_content'
                            | translate
                            : {
                            connectorId: connectorConfig?.id || '',
                          }
                          }}
                        </ix-modal-content>
                        <ix-modal-footer>
                          <ix-button
                            (click)="modal.close(true)"
                            class="dismiss-modal"
                            id="orgFormCancelEditModalYesButton"
                            onkeypress=""
                            variant="secondary"
                            >
                            {{ 'general.yes' | translate }}
                          </ix-button>
                          <ix-button
                            (click)="modal.dismiss()"
                            class="close-modal"
                            id="orgFormCancelEditModalNoButton"
                            onkeypress=""
                            variant="primary"
                            >
                            {{ 'general.no' | translate }}
                          </ix-button>
                        </ix-modal-footer>
                      </ix-modal>
                    </ng-template>
